import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadPendingCounts, loadPendingCountsSuccess } from './pendingCounts.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { CountsService } from '@services';

@Injectable()
export class PendingCountsEffects {
  constructor(
    private actions$: Actions,
    private countService: CountsService,
    private toast: ToastrService,
  ) {}
  loadPendingCounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPendingCounts),
      mergeMap(() =>
        this.countService.getPendingCounts().pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              return loadPendingCountsSuccess({ pendingCounts: response.data });
            } else {
              this.toast.error(response.message);
              return { type: '[Pending Counts] Load Pending Counts Failed' };
            }
          }),
          catchError((error: any) => {
            this.toast.error(error);
            return of({ type: '[Pending Counts] Load Pending Counts Failed' });
          }),
        ),
      ),
    ),
  );
}
